import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";
import { GroupHome } from "./GroupHome";
import { FilingsDashboard } from "v2/pages/FilingsDashboard/FilingsDashboard";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

export const GroupHomePage = ({ groupId }: { groupId: string }) => {
  const isV2Platform = useIsGroupV2Platform();
  const { has_paid_for_tax_filing } = useCurrentGroupContext();

  if (isV2Platform && !has_paid_for_tax_filing) {
    return <FilingsDashboard />;
  }

  return <GroupHome groupId={groupId} />;
};
